export default "__VITE_ASSET__5fa31017__"